export default "__VITE_ASSET__72012416__"